/* eslint-disable max-len */
import React, { useCallback, useMemo, useState } from 'react';
import { Container, Boxmodel, Header, Title, Blockcontent, Maincontent, Div, ShowTask, Showhide } from './styles';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { StatusListInterface } from '../../../../../interfaces/ProjectInterface';
import { isEmpty } from '../../../../../helpers/common';
import DeleteModal from '../../../../../component/models/deleteModel';
import { useHotkeys } from 'react-hotkeys-hook';
import {
  COMMENT_TYPE,
  SHOW_TASK_BY_ORDER,
  SHOW_TASK_GROUPING_TYPE,
  STATUS_TYPE,
  TASK_PRIORITY
} from '../../../../../global/constants';
import ModalCustom from '../../../../../component/models/modal';
import { createNewComment, updateTaskDetails } from '../../../../../services/taskServices';
import Taskgridloading from '../../../../../component/loading/taskgridloading';
import { trackAnalyticActivity } from '../../../../../services/analyticsService';
import { Droppable, Draggable, DragDropContext, DropResult } from 'react-beautiful-dnd';
import { MobxFilteredTasksListInterface } from '../../../../../interfaces/TaskInterface';
import { captureException } from '../../../../../services/logService';
import Calendarviewcard from '../../../../../component/calendarviewCard';
import ConfirmationModal from '../../../../../component/models/confirmationModal';
import { TASK_ANALYTICS } from '../../../../../global/analyticsConstants';
import { rootStore } from '../../../../../mobx/rootStore';
import MyCustomContextMenuV2 from '../../../../../component/customContextMenu/customContextMenuV2';
import { TaskModel } from '../../../../../mobx/models/task';
import { Milestone } from '../../../../../mobx/interfaces/project';
import { observer } from 'mobx-react-lite';
import { checkSubtaskStatus, dispatchTaskUpdates, onUpdateStatus } from '../../../../../services/taskActionService';
import CollapseDropdown from '../../../../../component/dropdowns/collapseDropdown';
import CreateTaskModalV2 from '../../../../../component/models/createTaskModal/createTaskModalV2';
import { defaultDisplayFilters } from '../../../../../mobx/common';

// eslint-disable-next-line @typescript-eslint/no-redeclare
declare type DropResult = typeof import('react-beautiful-dnd');
// eslint-disable-next-line @typescript-eslint/no-redeclare
declare type DraggableProvided = typeof import('react-beautiful-dnd');
interface Props {
  loadData: () => void;
  propsLoading?: boolean;
  isView?: boolean;
}

const TaskGrid: React.FC<Props> = (props) => {
  const { loadData, propsLoading, isView } = props;
  // States
  const [currentActiveTask, setCurrentActiveTask] = useState<string>('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [isOpenFromShortcut, setIsOpenFromShortcut] = useState(false);
  const [selectedItem, setSelectedItem] = useState<TaskModel>();
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [showcomplatedtask, setShowcomplatedtask] = useState(false);
  const [selectedId, setSelectedId] = useState('');
  const [isConfirmationModelOpen, setIsConfirmationModelOpen] = useState(false);
  const [confirmationLoading, setConfirmationLoading] = useState(false);
  const [currentTask, setCurrentTask] = useState<TaskModel>();
  const [cancelLoading, setCancelLoading] = useState(false);
  const [status, setStatus] = useState<StatusListInterface>();
  const [previousStatus, setPreviousStatus] = useState<StatusListInterface>();
  const [collapseIds, setCollapseIds] = useState<string[]>([]);
  const loading = propsLoading;

  //Mobx store variables
  const { projectStore, viewStore, workspaceStore } = rootStore;
  const { currentProject } = projectStore;
  const { taskFilterType: projectTaskFilter, filteredProjectTasks } = currentProject || {};
  const { groupingStatus } = projectTaskFilter || {};
  const { currentView, createViewInput } = viewStore;
  const { currentWorkspace: workspace } = workspaceStore;
  const { filteredTasks: filteredTasksList, otherTasks: otherTask } = isView
    ? viewStore.viewTasks
    : filteredProjectTasks || {
        filteredTasks: [],
        otherTasks: { tasks: [], completedTasks: [] }
      };

  // Other variables
  const taskFilter = isView
    ? createViewInput?.id
      ? createViewInput?.displayFilters || defaultDisplayFilters
      : currentView?.displayFilters
    : projectTaskFilter;
  const dispatch = useDispatch();
  const history = useHistory();

  //toggle completed task
  const togglecomplatedtask = useCallback((value: boolean, id: string) => {
    if (!value) {
      setSelectedId('');
    }
    setSelectedId(id);
    setShowcomplatedtask(value);
  }, []);

  //open delete modal
  const OpenDeleteModal = useCallback((item: TaskModel) => {
    setSelectedItem(item);
    setIsModalOpen(true);
  }, []);

  //close delete modal
  const closeDeleteModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  //open confirmation modal
  const handleOpenConfirmationModal = useCallback(() => {
    setIsConfirmationModelOpen(true);
  }, []);

  //close confirmation modal
  const closeConfirmationModal = useCallback(() => {
    setIsConfirmationModelOpen(false);
  }, []);

  //handle edit task
  const onClickEdit = useCallback(async (task: TaskModel) => {
    rootStore.taskStore.createTaskInput.updateWith(task);
    setOpen(true);
  }, []);

  //handle clone task
  const onClickClone = useCallback(async (task: TaskModel) => {
    rootStore.taskStore.createTaskInput.updateWith(task);
    rootStore.taskStore.createTaskInput.setDueDate(null);
    rootStore.taskStore.createTaskInput.setId(undefined);
    setOpen(true);
  }, []);

  //create task close
  const close = useCallback(() => {
    setIsOpenFromShortcut(false);
    setOpen(false);
    rootStore.taskStore.createTaskInput.clear();
  }, []);

  //handle click task details
  const onClickTaskDetails = useCallback(
    (task: TaskModel) => {
      const eventProperties = {
        source: 'task list',
        title: task?.name || ''
      };
      trackAnalyticActivity(TASK_ANALYTICS.VIEW, eventProperties);
      rootStore.taskStore.setCurrentTask(task?.id);
      history.push(`/projects/details/${task?.projectId}/tasks/details/${task?.id}`);
    },
    [history]
  );

  //handle drag end
  const onDragEnd = useCallback(
    async (result: DropResult) => {
      if (isView) return;
      if (
        !result.destination ||
        taskFilter?.groupingStatus === SHOW_TASK_GROUPING_TYPE.NO_GROUPING ||
        taskFilter?.groupingStatus === SHOW_TASK_GROUPING_TYPE.GROUPING_BY_USER ||
        !filteredTasksList
      ) {
        return;
      }
      const sourceGroupId = result.source.droppableId;
      const destinationGroupId = result.destination.droppableId;
      const draggedTask = currentProject?.tasks?.find((task) => task.id === result.draggableId);

      if (!draggedTask) return;

      const sourceGroup = filteredTasksList?.find((group) => group.id === sourceGroupId);
      if (
        sourceGroupId === destinationGroupId &&
        taskFilter?.orderByStatus === SHOW_TASK_BY_ORDER.CUSTOM &&
        result?.destination?.index !== result.source.index
      ) {
        if (!sourceGroup) return;

        const draggedTaskIndex = sourceGroup?.tasks?.findIndex((task) => task.id === result.draggableId);
        const draggedTaskCompletedIndex = sourceGroup?.completedTasks?.findIndex(
          (task) => task.id === result.draggableId
        );

        if (draggedTaskIndex === -1 && draggedTaskCompletedIndex === -1) return;

        const groupTasks = draggedTaskIndex !== -1 ? sourceGroup.tasks || [] : sourceGroup.completedTasks || [];

        const newIndex = result?.destination?.index;
        let updatedTaskIndex: number;

        if (newIndex === 0) {
          const nextTaskIndex = groupTasks?.[0]?.index;
          updatedTaskIndex = nextTaskIndex ? nextTaskIndex - 50 : draggedTask.createdOn.getTime();
        } else if (newIndex === groupTasks?.length - 1) {
          const previousTaskIndex = groupTasks?.[groupTasks?.length - 1]?.index;
          updatedTaskIndex = previousTaskIndex ? previousTaskIndex + 50 : draggedTask?.createdOn.getTime();
        } else {
          if (result?.destination?.index > result.source.index) {
            const previousTaskIndex: number = groupTasks[result?.destination?.index]?.index || 0;
            const nextTaskIndex: number = groupTasks[result?.destination?.index + 1]?.index || 0;
            updatedTaskIndex = (previousTaskIndex + nextTaskIndex) / 2;
          } else {
            const previousTaskIndex: number = groupTasks[result?.destination?.index - 1]?.index || 0;
            const nextTaskIndex: number = groupTasks[result?.destination?.index]?.index || 0;
            updatedTaskIndex = (previousTaskIndex + nextTaskIndex) / 2;
          }
        }
        draggedTask?.setIndex(updatedTaskIndex);
        const payloadTask = { index: updatedTaskIndex, projectId: currentProject?.id };
        await dispatch(updateTaskDetails(result?.draggableId, payloadTask));
        return;
      }

      const destinationGroup = filteredTasksList?.find((group) => group.id === destinationGroupId);
      if (sourceGroup && destinationGroup) {
        const draggedCompletedTaskIndex = destinationGroup?.completedTasks?.findIndex(
          (task) => task?.id === result?.draggableId
        );
        const newIndex = result?.destination?.index;
        let payload: {
          index?: number;
          groupId?: string;
          statusId?: string;
          milestoneId?: string;
          priority?: number;
        } = {};
        if (
          taskFilter?.groupingStatus === SHOW_TASK_GROUPING_TYPE.GROUPING_BY_GROUP ||
          (taskFilter?.groupingStatus === SHOW_TASK_GROUPING_TYPE.DEFAULT && currentProject?.isGroupEnabled)
        ) {
          draggedTask.setGroup(destinationGroupId);
          const taskGroups = draggedTask.project?.taskGroups;
          const previousGroup = taskGroups?.find((x) => x?.id === sourceGroupId);
          const updatedGroup = taskGroups?.find((x) => x?.id === destinationGroupId);
          dispatch(
            createNewComment(result?.draggableId, {
              Type: COMMENT_TYPE.CHANGE_GROUP,
              PreviousGroup: previousGroup?.name,
              Group: updatedGroup?.name
            })
          );
          payload = {
            groupId: destinationGroupId
          };
        } else if (taskFilter?.groupingStatus === SHOW_TASK_GROUPING_TYPE.GROUPING_BY_STATUS) {
          draggedTask.setStatus(destinationGroupId);
          const currentStatus = currentProject?.statusData?.find((x) => x['_id'] === destinationGroupId);
          const previousStatus = currentProject?.statusData?.find((x) => x['_id'] === sourceGroupId);
          dispatch(
            createNewComment(result?.draggableId, {
              Type: COMMENT_TYPE.STATUS_ID_CHANGE,
              PreviousGroup: previousStatus?.Name,
              Group: currentStatus?.Name,
              Priority: currentStatus?.Type
            })
          );
          payload = {
            statusId: destinationGroupId
          };
        } else if (taskFilter?.groupingStatus === SHOW_TASK_GROUPING_TYPE.GROUPING_BY_MILESTONE) {
          draggedTask.setMilestone(destinationGroupId);
          const milestoneList = draggedTask?.project?.milestones || [];
          const milestone = milestoneList?.find((x) => x?.id === destinationGroupId);
          dispatch(
            createNewComment(result?.draggableId, {
              Type: COMMENT_TYPE.SET_MILESTONE,
              Group: milestone?.milestoneName
            })
          );
          payload = {
            milestoneId: destinationGroupId
          };
        } else if (taskFilter?.groupingStatus === SHOW_TASK_GROUPING_TYPE.GROUPING_BY_PRIORITY) {
          draggedTask.setPriority(destinationGroupId);
          dispatch(
            createNewComment(result?.draggableId, {
              Type: COMMENT_TYPE.CHANGE_PRIORITY,
              PreviousPriority: Number(sourceGroupId) === 5 ? TASK_PRIORITY.NO_PRIORITY : Number(sourceGroupId),
              Priority: Number(destinationGroupId) === 5 ? TASK_PRIORITY.NO_PRIORITY : Number(destinationGroupId)
            })
          );
          if (draggedTask.priority === 5) {
            payload = {
              priority: TASK_PRIORITY.NO_PRIORITY
            };
          } else {
            payload = {
              priority: destinationGroupId
            };
          }
        }
        const destinationTasks =
          draggedCompletedTaskIndex === -1 ? destinationGroup?.tasks : destinationGroup?.completedTasks;
        let newTaskIndex = 0;
        if (taskFilter?.orderByStatus === SHOW_TASK_BY_ORDER.CUSTOM) {
          if (destinationTasks && (destinationTasks?.length === 0 || newIndex >= destinationTasks?.length)) {
            newTaskIndex =
              destinationTasks?.length === 0
                ? draggedTask.createdOn.getTime()
                : destinationTasks?.[destinationTasks?.length - 1]?.index + 50;
          } else if (newIndex === 0) {
            const nextTaskIndex = destinationTasks?.[0]?.index;
            newTaskIndex = nextTaskIndex ? nextTaskIndex - 50 : draggedTask.createdOn.getTime();
          } else {
            const previousTaskIndex = destinationTasks?.[newIndex - 1]?.index || 0;
            const nextTaskIndex = destinationTasks?.[newIndex]?.index || 0;
            newTaskIndex = (previousTaskIndex + nextTaskIndex) / 2;
          }
          draggedTask.setIndex(newTaskIndex);
        }
        if (taskFilter?.orderByStatus === SHOW_TASK_BY_ORDER.CUSTOM) {
          payload.index = newTaskIndex;
        }
        const payloadTask = { ...(payload || {}), projectId: currentProject?.id };
        const resultUpdate = await dispatch(updateTaskDetails(result?.draggableId, payloadTask));
        if (resultUpdate) {
          trackAnalyticActivity(TASK_ANALYTICS.GROUP_CHANGED);
        }
      }
    },
    [
      currentProject?.id,
      currentProject?.isGroupEnabled,
      currentProject?.statusData,
      currentProject?.tasks,
      dispatch,
      filteredTasksList,
      isView,
      taskFilter?.groupingStatus,
      taskFilter?.orderByStatus
    ]
  );

  //handle delete task
  const deleteTask = useCallback(
    async (task: TaskModel) => {
      try {
        setDeleteLoading(true);
        const payloadTask = { isArchived: true, projectId: task?.projectId };
        const response = await dispatch(updateTaskDetails(task?.id, payloadTask));
        setIsModalOpen(false);
        setSelectedItem(undefined);
        if (response) {
          rootStore.taskStore.removeTasks([task?.id]);
        }
      } catch (error) {
        captureException(error);
        console.log('error', error);
      } finally {
        setDeleteLoading(false);
      }
    },
    [dispatch]
  );

  useHotkeys('c', async () => {
    setTimeout(async () => {
      setIsOpenFromShortcut(true);
      setOpen(true);
      rootStore.taskStore.createTaskInput.setProject(currentProject?.id || '');
    }, 100);
  });

  //handle task milestone
  const updateTaskMilestone = useCallback(
    async (currentTask: TaskModel, milestone: Milestone) => {
      currentTask.setMilestone(milestone?.id);
      const payloadTask = { milestoneId: milestone?.id, projectId: currentTask?.projectId };
      const result = await dispatch(updateTaskDetails(currentTask?.id, payloadTask));
      const commentResult = await dispatch(
        createNewComment(currentTask?.id, {
          Type: COMMENT_TYPE.SET_MILESTONE,
          Group: milestone?.milestoneName
        })
      );
      if (result && commentResult && loadData) {
        loadData();
      }
    },
    [dispatch, loadData]
  );

  //handle remove milestone
  const onRemoveMilestone = useCallback(
    async (task: TaskModel) => {
      if (!isEmpty(task?.milestoneId)) {
        task.setMilestone('No Milestone');
        const payloadTask = { milestoneIdUnset: true, projectId: task?.projectId };
        await dispatch(updateTaskDetails(task?.id, payloadTask));
      }
    },
    [dispatch]
  );

  const handleCollapseClick = useCallback(
    (id: string) => {
      const groupId = String(id);
      if (collapseIds.includes(groupId)) {
        const updatedIds = collapseIds.filter((id) => id !== groupId);
        setCollapseIds(updatedIds);
      } else {
        setCollapseIds([...collapseIds, groupId]);
      }
    },
    [collapseIds]
  );

  const onChangeStatus = useCallback(
    (task: TaskModel, status: StatusListInterface, previousStatus: StatusListInterface) => {
      const isSubtaskRemaining = checkSubtaskStatus(task);
      if (status.Type === STATUS_TYPE.COMPLETED && !isSubtaskRemaining) {
        handleOpenConfirmationModal();
        setStatus(status);
        setPreviousStatus(previousStatus);
        setCurrentTask(task);
        return;
      }
      onUpdateStatus(task, status, previousStatus, false, dispatch);
    },
    [dispatch, handleOpenConfirmationModal]
  );

  //Handle checkbox click when project status is disabled
  const onClickTaskCheckBox = useCallback(
    (task: TaskModel, status: boolean) => {
      const isSubtaskRemaining = checkSubtaskStatus(task);
      if (status && !isSubtaskRemaining) {
        handleOpenConfirmationModal();
        setCurrentTask(task);
        return;
      }
      task.setStatus(status, false);
      dispatchTaskUpdates(task, status, dispatch);
      loadData?.();
    },
    [dispatch, handleOpenConfirmationModal, loadData]
  );

  //Handle Yes button click for confirmation model
  const onClickConfirm = useCallback(() => {
    if (!currentTask) return;
    try {
      setConfirmationLoading(true);
      if (currentTask.project?.statusEnable && status && previousStatus) {
        onUpdateStatus(currentTask, status, previousStatus, true, dispatch);
      } else {
        currentTask.setStatus(true, true);
        dispatchTaskUpdates(currentTask, true, dispatch);
        loadData?.();
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      setConfirmationLoading(false);
      closeConfirmationModal();
    }
  }, [closeConfirmationModal, currentTask, dispatch, loadData, previousStatus, status]);

  //Handle No button click for confirmation model
  const onClickNo = useCallback(() => {
    if (!currentTask) return;
    try {
      setCancelLoading(true);
      if (currentTask.project?.statusEnable && status && previousStatus) {
        onUpdateStatus(currentTask, status, previousStatus, false, dispatch);
      } else {
        currentTask.setStatus(true, false);
        dispatchTaskUpdates(currentTask, true, dispatch);
        loadData?.();
      }
    } catch (error) {
    } finally {
      setCancelLoading(false);
      closeConfirmationModal();
    }
  }, [closeConfirmationModal, currentTask, dispatch, loadData, previousStatus, status]);

  // render completed task data
  const renderDisplayCompletedTaskData = useCallback(
    (item: MobxFilteredTasksListInterface, comparedValue: string) => {
      return (
        selectedId === comparedValue &&
        showcomplatedtask &&
        item?.completedTasks &&
        item?.completedTasks?.length > 0 && (
          <>
            {item?.completedTasks?.map((task, taskIndex: number) => {
              if (item?.isCollapse) return <></>;
              return (
                <Draggable draggableId={task.id} index={taskIndex} key={task.id}>
                  {(provided: DraggableProvided) => (
                    <>
                      <MyCustomContextMenuV2
                        taskData={task}
                        loadData={loadData}
                        currentProject={task?.project!}
                        setCurrentActiveTask={(taskId: string) => setCurrentActiveTask(taskId)}
                        onClickView={() => onClickTaskDetails(task)}
                        onClickClone={() => onClickClone(task)}
                        onClickEdit={() => onClickEdit(task)}
                        statusList={task?.project?.statusData || []}
                        onClickDelete={() => OpenDeleteModal(task)}
                        onUpdateStatus={(status: StatusListInterface, previousStatus: StatusListInterface) =>
                          onChangeStatus(task, status, previousStatus)
                        }>
                        <Blockcontent
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          id={task?.id}
                          key={task?.id}>
                          <Calendarviewcard
                            taskDetails={task}
                            currentProject={task?.project!}
                            currentActiveTask={currentActiveTask}
                            isTaskGrid={true}
                            loadData={loadData}
                            onClickCurrentTaskCheckbox={() => onClickTaskCheckBox(task, !task.status)}
                            onUpdateStatus={(status: StatusListInterface, previousStatus: StatusListInterface) =>
                              onChangeStatus(task, status, previousStatus)
                            }
                            onClickDelete={() => OpenDeleteModal(task)}
                            onClickClone={() => onClickClone(task)}
                            onClickEdit={() => onClickEdit(task)}
                            onClickView={() => onClickTaskDetails(task)}
                            onUpdateMilestone={(milestone) => updateTaskMilestone(task, milestone)}
                            isView={isView}
                          />
                        </Blockcontent>
                      </MyCustomContextMenuV2>
                    </>
                  )}
                </Draggable>
              );
            })}
          </>
        )
      );
    },
    [
      OpenDeleteModal,
      currentActiveTask,
      isView,
      loadData,
      onChangeStatus,
      onClickClone,
      onClickEdit,
      onClickTaskCheckBox,
      onClickTaskDetails,
      selectedId,
      showcomplatedtask,
      updateTaskMilestone
    ]
  );

  // render completed task data
  const renderCompletedTaskData = useCallback(
    (item: MobxFilteredTasksListInterface, comparedValue: string) => {
      return (
        item?.completedTasks &&
        item?.completedTasks?.length > 0 && (
          <ShowTask>
            {selectedId === comparedValue && showcomplatedtask ? (
              <Showhide onClick={() => togglecomplatedtask(false, '')}>Hide Completed Tasks</Showhide>
            ) : (
              <Showhide
                onClick={() =>
                  togglecomplatedtask(
                    true,
                    groupingStatus === SHOW_TASK_GROUPING_TYPE.GROUPING_BY_USER ||
                      groupingStatus === SHOW_TASK_GROUPING_TYPE.GROUPING_BY_PRIORITY
                      ? `${item?.name}` || ''
                      : `${item?.id}` || ''
                  )
                }>
                Show Completed Tasks
              </Showhide>
            )}
            {renderDisplayCompletedTaskData(item, comparedValue)}
          </ShowTask>
        )
      );
    },
    [groupingStatus, renderDisplayCompletedTaskData, selectedId, showcomplatedtask, togglecomplatedtask]
  );

  // get compared value
  const getComparedValue = useCallback(
    (item: MobxFilteredTasksListInterface) => {
      let comparedValue;
      if (
        groupingStatus === SHOW_TASK_GROUPING_TYPE.GROUPING_BY_USER ||
        groupingStatus === SHOW_TASK_GROUPING_TYPE.GROUPING_BY_PRIORITY
      ) {
        comparedValue = item?.name;
      } else {
        comparedValue = item?.id || '';
      }
      return comparedValue.toString();
    },
    [groupingStatus]
  );

  // render filter task list
  const renderFilterTaskList = useMemo(() => {
    return filteredTasksList?.map((item) => {
      let comparedValue = getComparedValue(item);
      return (
        <Droppable droppableId={item.id} key={item.id}>
          {(provided: DraggableProvided) => (
            <Boxmodel key={item?.id} ref={provided.innerRef} {...provided.droppableProps}>
              {!isEmpty(item?.name) && (
                <Header isHide={groupingStatus === SHOW_TASK_GROUPING_TYPE.NO_GROUPING}>
                  <Title>{item?.name}</Title>
                  <CollapseDropdown
                    groupDetail={item}
                    loadData={loadData}
                    isWidth={true}
                    workspaceDetail={workspace}
                    collapseIds={collapseIds}
                    setCollapse={handleCollapseClick}
                  />
                </Header>
              )}
              <Div className='desktop-div-gridview'>
                {item?.tasks?.map((task, taskIndex: number) => {
                  if (collapseIds.includes(String(item.id))) return <></>;
                  return (
                    <Draggable draggableId={task.id} index={taskIndex} key={task.id}>
                      {(provided: DraggableProvided) => (
                        <>
                          <MyCustomContextMenuV2
                            taskData={task}
                            loadData={loadData}
                            currentProject={task?.project!}
                            setCurrentActiveTask={(taskId: string) => setCurrentActiveTask(taskId)}
                            onClickView={() => onClickTaskDetails(task)}
                            onClickClone={() => onClickClone(task)}
                            onClickEdit={() => onClickEdit(task)}
                            statusList={task?.project?.statusData || []}
                            onClickDelete={() => OpenDeleteModal(task)}
                            onUpdateStatus={(status: StatusListInterface, previousStatus: StatusListInterface) =>
                              onChangeStatus(task, status, previousStatus)
                            }
                            isView={isView}>
                            <Blockcontent
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              id={task?.id}
                              key={task?.id}>
                              <Calendarviewcard
                                taskDetails={task}
                                currentProject={task?.project!}
                                isTaskGrid={true}
                                loadData={loadData}
                                onClickCurrentTaskCheckbox={() => onClickTaskCheckBox(task, !task.status)}
                                onUpdateStatus={(status: StatusListInterface, previousStatus: StatusListInterface) =>
                                  onChangeStatus(task, status, previousStatus)
                                }
                                onClickDelete={() => OpenDeleteModal(task)}
                                onClickClone={() => onClickClone(task)}
                                onClickEdit={() => onClickEdit(task)}
                                onClickView={() => onClickTaskDetails(task)}
                                onUpdateMilestone={(milestone) => updateTaskMilestone(task, milestone)}
                                onRemoveMilestone={() => onRemoveMilestone(task)}
                                currentActiveTask={currentActiveTask}
                              />
                            </Blockcontent>
                          </MyCustomContextMenuV2>
                        </>
                      )}
                    </Draggable>
                  );
                })}
                {provided?.placeholder}
                {renderCompletedTaskData(item, comparedValue)}
              </Div>
            </Boxmodel>
          )}
        </Droppable>
      );
    });
  }, [
    OpenDeleteModal,
    collapseIds,
    currentActiveTask,
    filteredTasksList,
    getComparedValue,
    groupingStatus,
    handleCollapseClick,
    isView,
    loadData,
    onChangeStatus,
    onClickClone,
    onClickEdit,
    onClickTaskCheckBox,
    onClickTaskDetails,
    onRemoveMilestone,
    renderCompletedTaskData,
    updateTaskMilestone,
    workspace
  ]);

  // render other task data
  const renderOtherTask = useMemo(() => {
    return otherTask?.tasks?.map((item) => {
      return (
        <>
          <MyCustomContextMenuV2
            taskData={item}
            loadData={loadData}
            currentProject={item?.project!}
            setCurrentActiveTask={(taskId: string) => setCurrentActiveTask(taskId)}
            onClickView={() => onClickTaskDetails(item)}
            onClickClone={() => onClickClone(item)}
            onClickEdit={() => onClickEdit(item)}
            statusList={item?.project?.statusData || []}
            onClickDelete={() => OpenDeleteModal(item)}
            onUpdateStatus={(status: StatusListInterface, previousStatus: StatusListInterface) =>
              onChangeStatus(item, status, previousStatus)
            }
            isView={isView}>
            <Blockcontent key={item?.id}>
              <Calendarviewcard
                taskDetails={item}
                currentProject={item?.project!}
                isTaskGrid={true}
                loadData={loadData}
                onClickCurrentTaskCheckbox={() => onClickTaskCheckBox(item, !item.status)}
                onClickDelete={() => OpenDeleteModal(item)}
                onClickClone={() => onClickClone(item)}
                onClickEdit={() => onClickEdit(item)}
                onClickView={() => onClickTaskDetails(item)}
                onUpdateMilestone={(milestone) => updateTaskMilestone(item, milestone)}
                isView={isView}
              />
            </Blockcontent>
          </MyCustomContextMenuV2>
        </>
      );
    });
  }, [
    OpenDeleteModal,
    isView,
    loadData,
    onChangeStatus,
    onClickClone,
    onClickEdit,
    onClickTaskCheckBox,
    onClickTaskDetails,
    otherTask?.tasks,
    updateTaskMilestone
  ]);

  // render other completed task
  const renderOtherCompletedTask = useMemo(() => {
    return (
      otherTask?.completedTasks &&
      otherTask?.completedTasks?.length > 0 && (
        <ShowTask>
          {selectedId === 'otherTasks' && showcomplatedtask ? (
            <Showhide onClick={() => togglecomplatedtask(false, '')}>Hide Completed Tasks</Showhide>
          ) : (
            <Showhide onClick={() => togglecomplatedtask(true, 'otherTasks')}>Show Completed Tasks</Showhide>
          )}
          {selectedId === 'otherTasks' && showcomplatedtask && otherTask?.completedTasks?.length > 0 && (
            <>
              {otherTask?.completedTasks?.map((item) => {
                return (
                  <Blockcontent key={item?.id}>
                    <Calendarviewcard
                      taskDetails={item}
                      isTaskGrid={true}
                      loadData={loadData}
                      onClickCurrentTaskCheckbox={() => onClickTaskCheckBox(item, !item.status)}
                      onClickDelete={() => OpenDeleteModal(item)}
                      onClickClone={() => onClickClone(item)}
                      onClickEdit={() => onClickEdit(item)}
                      onClickView={() => onClickTaskDetails(item)}
                      onUpdateMilestone={(milestone) => updateTaskMilestone(item, milestone)}
                      isView={isView}
                    />
                  </Blockcontent>
                );
              })}
            </>
          )}
        </ShowTask>
      )
    );
  }, [
    OpenDeleteModal,
    isView,
    loadData,
    onClickClone,
    onClickEdit,
    onClickTaskCheckBox,
    onClickTaskDetails,
    otherTask?.completedTasks,
    selectedId,
    showcomplatedtask,
    togglecomplatedtask,
    updateTaskMilestone
  ]);

  //render all task data
  const renderTaskData = useMemo(() => {
    if (
      filteredTasksList?.length > 0 ||
      otherTask?.tasks?.length > 0 ||
      (otherTask?.completedTasks && otherTask?.completedTasks?.length > 0)
    ) {
      return (
        <>
          {renderFilterTaskList}
          {(otherTask?.tasks?.length > 0 || (otherTask?.completedTasks && otherTask?.completedTasks?.length > 0)) && (
            <Boxmodel>
              <Header isHide={groupingStatus === SHOW_TASK_GROUPING_TYPE.NO_GROUPING}>
                <Title>Other Tasks</Title>
              </Header>
              <Div>
                {renderOtherTask}
                {renderOtherCompletedTask}
              </Div>
            </Boxmodel>
          )}
        </>
      );
    }
  }, [
    filteredTasksList?.length,
    otherTask?.tasks?.length,
    otherTask?.completedTasks,
    renderFilterTaskList,
    groupingStatus,
    renderOtherTask,
    renderOtherCompletedTask
  ]);

  return (
    <>
      <DragDropContext onDragEnd={onDragEnd}>
        <Maincontent className='desktop-main-content-grid-view'>
          {loading && filteredTasksList?.length === 0 && <Taskgridloading />}
          <Container>{renderTaskData}</Container>
          <ModalCustom open={isModalOpen} onClose={closeDeleteModal} width={334}>
            <DeleteModal
              onClose={closeDeleteModal}
              onOk={() => selectedItem && deleteTask(selectedItem)}
              loading={deleteLoading}
              modalTitle='Delete Task?'
              description='Are you sure you want to delete this task?'
            />
          </ModalCustom>
          <ModalCustom open={open} onClose={close} isCreateTask={true}>
            <CreateTaskModalV2 loadData={loadData} onCancel={close} isFromShortcut={isOpenFromShortcut} />
          </ModalCustom>
          <ModalCustom open={isConfirmationModelOpen} onClose={closeConfirmationModal} width={334}>
            <ConfirmationModal
              loading={confirmationLoading}
              cancelLoading={cancelLoading}
              onOk={onClickConfirm}
              onNo={onClickNo}
              onClose={closeConfirmationModal}
              modalTitle='Uncompleted Subtasks'
              description='Do you want to complete all these subtasks?'
            />
          </ModalCustom>
        </Maincontent>
      </DragDropContext>
    </>
  );
};

export default observer(TaskGrid);
